export default (errorData) => {
  // schema para recuperar el error especifico cuando el codigo es 500601
  return {
    event: 'error',
    type: errorData.type, // Error type
    statusCode: errorData.statusCode, // HTTP Status Code
    code: ( errorData.code ) ? errorData.code : 'null', // Error code
    actionable: ( errorData.actionable ) ? errorData.actionable : 'null', // action that can be taken
    actionType: errorData.actionType,
    errorMsg: ( errorData.message ) ? errorData.message : 'null',
    errorExtraInfo: ( errorData.extraInfo ) ? errorData.extraInfo : 'null', // dynamic data

  };
};
  